import Calendario from '../components/Calendario'
import ModalInfoEventoCalendario from '../components/ModalInfoEventoCalencadario'
import ModalNovoEventoCalendario from '../components/ModalNovoEventoCalendario'
import calendarioGerencial from '../mixins/calendarioGerencial'
import InfoEventoCalendario from '../components/InfoEventoCalendario'
import { clientePfService } from '../services/clientePf.service'
import { fundacaoService } from '../services/fundacao.service'
import { clientAssetsService } from '../services/client-assets.service'
import acessos from '../mixins/acessos'

const { getClientesPf } = clientePfService()
const { getFundacoes, getInformacoesFundacao } = fundacaoService()
const { getInfoAtendimentoCliente } = clientAssetsService()

const { showToastify } = GLOBAL

const TIPO_USUARIO = {
	CLIENTE_PF: 'PF',
	FUNDACAO: 'FUNDACAO',
}

export default {
	props: {},
	emits: [],
	mixins: [calendarioGerencial, acessos],
	components: {
		Calendario,
		ModalInfoEventoCalendario,
		ModalNovoEventoCalendario,
		InfoEventoCalendario,
	},
	data() {
		return {
			eventosCalendario: [],
			infoEventoCalendario: null,
			isEditModoEvento: false,
			editEventoCalendario: null,
			elementoEventoSelecionado: null,
			exibirInfoEvento: false,
			usuarioSelecionadoCalendario: null,
			optionsSelectCliente: [],
			optionsAtendimentoUsuario: [],
			optionsUsuariosCalendarios: [],
			isDoubleClick: false,
			isOpenModalNovoEvento: true,
			calendarioModoType: null,

			data: {
				cliente: {
					data: null,
					next: null,
					previous: null,
				},
				fundacao: {
					data: null,
					next: null,
					previous: null,
				},
			},
			loading: {
				todosUsuarios: false,
				isFirstLoad: false,
				carregandoEventos: false,
			},
		}
	},
	computed: {
		menuAnchor() {
			return this.calendarioModoType === 'timeGridWeek' ||
				this.calendarioModoType === 'timeGridDay'
				? 'center right'
				: 'bottom right'
		},
		menuSelf() {
			
			return this.calendarioModoType === 'timeGridWeek' ||
				this.calendarioModoType === 'timeGridDay'
				? 'center left'
				: 'bottom left'
		},
		menuOffset() {
			
			return this.calendarioModoType === 'timeGridWeek' ||
				this.calendarioModoType === 'timeGridDay'
				? [10, 0]
				: [10, 10]
		},
		loadingEventoCalendario() {
			return this.isEditModoEvento
				? this.loading.atualizaEvento
				: this.loading.novoEvento
		},
		deleteLoadingEventoCalendario() {
			return this.loading.deletaEvento
		},
	},
	watch: {
		async usuarioSelecionadoCalendario(newVal) {
			if (newVal) {
				await this.carregarEventosCalendarioUsuarioSelecionado()
			} else {
				await this.carregarEventosCalendario()
			}
		},
	},
	methods: {
		async authEmail() {
			const responseCalendario = await this.calendarioAuth()

			if (responseCalendario && responseCalendario.auth_url) {
				window.open(responseCalendario.auth_url, '_blank')
			}
		},

		openModalNovoEventoCalendario() {
			modal_padrao_vue.openModal('modal_novo_evento_calendario')
			const modais = document.querySelectorAll(
				'[data-active="modal_novo_evento_calendario"]'
			)

			modais.forEach((modal) => {
				modal.style.width = '48rem'
			})

			this.isOpenModalNovoEvento = true
		},

		openModalInfoEventoCalendario() {
			modal_padrao_vue.openModal('modal_info_evento_calendario')
			const modais = document.querySelectorAll(
				'[data-active="modal_info_evento_calendario"]'
			)

			modais.forEach((modal) => {
				modal.style.width = '19rem'
				modal.style.minWidth = '1rem'
				modal.style.height = 'content'
				modal.style.minHeight = '1rem'
			})
		},

		closeModalNovoEventoCalendario() {
			this.$refs.modalNovoEvento.resetarCamposModal()
			this.isEditModoEvento = false
			this.isDoubleClick = false
			this.editEventoCalendario = null
			this.isOpenModalNovoEvento = false
			modal_padrao_vue.closeModal('modal_novo_evento_calendario')
		},

		closeModalInfoEventoCalendario() {
			this.exibirInfoEvento = null
		},

		formatarConvidadosApi(convidados) {
			return convidados.map((email) => ({
				emailAddress: {
					address: email,
					name: email.split('@')[0],
				},
				type: 'required',
			}))
		},

		onClickInfoCalendario(evento) {
			this.calendarioModoType = evento.view.type
			this.infoEventoCalendario = evento.event._def
			this.elementoEventoSelecionado = evento.el
			this.exibirInfoEvento = true
		},

		onClickEditEventoCalendario() {
			const idEvento = this.infoEventoCalendario?.publicId || null
			const evento = this.eventosCalendario.find((ev) => ev.id === idEvento)
			if (evento) {
				this.isEditModoEvento = true
				this.editEventoCalendario = evento
				this.closeModalInfoEventoCalendario()
				setTimeout(() => {
					this.openModalNovoEventoCalendario()
				}, 500)
			}
		},
		onDoubleClickEditEventoCalendario(evento) {
			const idEvento = evento.event._def.publicId || evento.event.id
			const eventoEdit = this.eventosCalendario.find((ev) => ev.id === idEvento)

			if (eventoEdit) {
				this.exibirInfoEvento = false
				this.isEditModoEvento = true
				this.isDoubleClick = true
				this.editEventoCalendario = eventoEdit
				this.openModalNovoEventoCalendario()
			}
		},

		montarPayloadEvento(data) {
			const payload = {
				subject: data.titulo,
				start: {
					dateTime: data.dataEventoInicio,
					timeZone: 'America/Sao_Paulo',
				},
				end: {
					dateTime: data.dataEventoFim,
					timeZone: 'America/Sao_Paulo',
				},
				location: {
					displayName: data.localEvento || '',
				},
				attendees: this.formatarConvidadosApi(data.convidados),
				isAllDay: !!data.isDiaInteiro,
				isOnlineMeeting: !!data.isTeams,
				body: {
					contentType: 'HTML',
					content: data.descricaoEvento || '',
				},
				id: data?.id,
				isReminderOn: !!data.lembreteAtendimento,
				reminderMinutesBeforeStart: data.lembreteAtendimento || 0,
				atendimento_data: {
					gerar_atendimento: data.tipoClienteAtendimento,
					cliente_id: data.usuarioSelecionado?.id || null,
					tipo: data.tipoAtendimento,
					politica_atendimento_id: data?.dataPolitica || null,
				},
			}

			return payload
		},

		async initOptionsSelectCliente() {
			try {
				this.loading.todosUsuarios = true
				await Promise.all([this.setClientesPfs(), this.setFundacoes()])

				const optionClientePf =
					this.data.cliente?.data?.map((cliente) => ({
						label: cliente.nome,
						value: { id: cliente.id, tipo: TIPO_USUARIO.CLIENTE_PF },
					})) || []

				const optionFundacao =
					this.data.fundacao?.data?.map((fundacao) => ({
						label: fundacao.sigla,
						value: { id: fundacao.id, tipo: TIPO_USUARIO.FUNDACAO },
					})) || []

				this.optionsSelectCliente = [...optionClientePf, ...optionFundacao]
			} finally {
				this.loading.todosUsuarios = false
			}
		},

		async initOpionsUsuariosCalendarios() {
			try {
				this.loading.todosUsuarios = true
				const usuariosCalendarios = await this.buscarUsuariosCalendarios()

				this.optionsUsuariosCalendarios =
					usuariosCalendarios.map((usuario) => ({
						label: usuario.displayName,
						value: usuario.id,
					})) || []
			} finally {
				this.loading.todosUsuarios = false
			}
		},

		async setClientesPfs(page = 1, search = '') {
			try {
				const params = {
					page: page,
					search: search,
				}

				const responseClientes = await getClientesPf(params)

				this.data.cliente.data = responseClientes?.results || []
				this.data.cliente.next = responseClientes?.next || null
				this.data.cliente.previous = responseClientes?.previous || null
			} catch (error) {
				console.error('Erro ao buscar clientes PF:', error)
			}
		},

		async setFundacoes(page = 1, search = '') {
			try {
				const params = {
					page: page,
					search: search,
				}

				const responseFundacoes = await getFundacoes(params)

				this.data.fundacao.data = responseFundacoes?.results || []
				this.data.fundacao.next = responseFundacoes?.next || null
				this.data.fundacao.previous = responseFundacoes?.previous || null
			} catch (error) {
				console.error('Erro ao buscar fundações:', error)
			}
		},

		async carregarEventosCalendario() {
			this.loading.carregandoEventos = true
			try {
				this.eventosCalendario = await this.buscarEventosFormatados()
			} catch (error) {
				console.error('Erro ao carregar eventos do calendário:', error)
			} finally {
				this.loading.carregandoEventos = false
			}
		},

		async carregarEventosCalendarioUsuarioSelecionado() {
			this.loading.carregandoEventos = true

			try {
				this.eventosCalendario =
					await this.buscarEventosUsuarioSelecionadoFormatados({
						id: this.usuarioSelecionadoCalendario?.value,
					})
			} catch (error) {
				console.error('Erro ao carregar eventos do calendário:', error)
			} finally {
				this.loading.carregandoEventos = false
			}
		},

		async criarEventoCalendario(data) {
			const payload = this.montarPayloadEvento(data)

			await this.criarEvento(payload)
			if (!this.error.novoEvento && this.loading.novoEvento === false) {
				showToastify('✅ Evento criado com sucesso.')
				this.closeModalNovoEventoCalendario()
				await this.carregarEventosCalendario()
			}
		},

		async atualizarEventoCalendario(data) {
			const payload = this.montarPayloadEvento(data)
			await this.atualizarEvento(payload)
			if (!this.error.atualizaEvento && this.loading.atualizaEvento === false) {
				showToastify('✅ Evento atualizado com sucesso.')
				this.closeModalNovoEventoCalendario()
				await this.carregarEventosCalendario()
			}
		},

		async excluirCalendario(id, data) {
			if (!id) return

			const payload = {
				body: {
					contentType: 'HTML',
					content: data?.mensagemExclusao || '',
				},
			}

			await this.deletarEvento(id, payload)

			if (!this.error.deletaEvento && this.loading.deletaEvento === false) {
				showToastify('✅ Evento excluído com sucesso.')
				this.closeModalInfoEventoCalendario()
				this.closeModalNovoEventoCalendario()
				await this.carregarEventosCalendario()
			}
		},

		async checkIsAutenticado() {
			if (this.eventosCalendario === null) {
				await this.authEmail()
			}
		},

		async initAllConfigs() {
			await this.carregarEventosCalendario()
			await this.checkIsAutenticado()
			await this.initOpionsUsuariosCalendarios()
		},

		checkGestorFundacao() {
			if (this.acessSAI) document.body.classList.add('sai')
		},
	},

	async mounted() {
		this.loading.isFirstLoad = true
		try {
			await new Promise((resolve) => setTimeout(resolve, 1000))
			await this.initAllConfigs()
		} catch (error) {
			console.error('Erro ao carregar eventos do calendário:', error)
		} finally {
			this.loading.isFirstLoad = false

			setTimeout(() => {
				this.checkGestorFundacao()
				console.log('Página Calendário de Reuniões carregada.')
			}, 200)
		}

		/* await this.initOptionsSelectCliente() */
	},

	delimiters: ['{*', '*}'],
}
